<script>
import Highlight from './_base-highlight.vue';

export default {
  components: { Highlight },
  props: {
    number: {
      type: Number,
      required: true
    },
    decimals: {
        type: Number,
        required: false,
        default: null
    }
  },
  computed: {
    roundedNumber() {
        if(this.decimals === null) {
            return this.number;
        }
        return Math.round(this.number * Math.pow(10, this.decimals)) / Math.pow(10, this.decimals);
    }
  }
}
</script>
<template>
  <Highlight>{{roundedNumber.toLocaleString()}}</Highlight>
</template>